module.exports = __webpack_public_path__ + "img/uploadicon.25059663.svg";